module.exports = __webpack_public_path__ + "static/media/8.6b8dfec6.jpg";